import React from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import BigButton from '../components/BigButton';
import { alphabetsData } from '../data/alphabets';
import { useSpeech } from '../hooks/useSpeech';
import './Alphabets.css';

const Alphabets = () => {
    const history = useHistory();
    const { speak } = useSpeech();

    const handleLetterClick = (item) => {
        speak(item.letter);
        setTimeout(() => {
            history.push(`/alphabets/${item.letter}`);
        }, 400);
    };

    return (
        <Layout title="Alphabets" onBack={() => history.push('/')}>
            <div className="alphabets-grid">
                {alphabetsData.map((item) => (
                    <BigButton
                        key={item.letter}
                        label={item.letter}
                        color={item.color}
                        onClick={() => handleLetterClick(item)}
                        className="alphabet-button"
                    />
                ))}
            </div>
        </Layout>
    );
};

export default Alphabets;
